export class UniqueEmailsRequiredError extends Error {
  constructor() {
    super(
      'Some participants of this proceeding share the same email address. Email addresses must be unique to a particular participant of a proceeding.',
    )
    Object.setPrototypeOf(this, UniqueEmailsRequiredError.prototype)
  }
}
